export default {
  server: {
    baseUrl: process.env.NX_REACT_APP_BASE_PATH
  },
  dataDog: {
    applicationId: process.env.NX_DD_APPLICATION_ID,
    clientToken: process.env.NX_DD_CLIENT_TOKEN,
    site: process.env.NX_DD_SITE,
    defaultPrivacyLevel: process.env.NX_DD_PRIVACY_LEVEL,
    service: process.env.NX_DD_SERVICE
  },
  appEnv: process.env.NX_REACT_APP_ENV,
  appEnvType: process.env.NX_REACT_APP_ENV_TYPE,
  isLocalMode: process.env.NX_REACT_APP_ENV === 'local',
  isStagingMode: process.env.NX_REACT_APP_ENV === 'staging01',
  google: {
    clientId: process.env.NX_REACT_APP_GOOGLE_CLIENT_ID
  },
  slack: process.env.NX_REACT_APP_SLACK_CHANNEL,
  prefixPath: '/reco'
};
